<template>
  <div class="m-4">
    <LoadedComponent :loading="loading" />
    <div class="container" v-if="!loading">
      <h3 class="text-center p-2">Visualizzazione dicom</h3>
      <a @click="$router.go(-1)" class="btn btn-link mb-2">Torna indietro</a>
      <dicom-component :dicoms="dicoms"></dicom-component>
    </div>
  </div>
</template>
<script>
import DicomComponent from "@/components/DicomComponent.vue";
import { useAuth } from "@/stores/auth.js";
import httpauth from "@/services/httpauth.js";

export default {
  name: "DicomPage",
  props: ["id"],
  components: { DicomComponent },
  data() {
    return {
      dicoms: [],
      loading: true,
    };
  },
  async mounted() {
    await httpauth
      .get("/attachments/show-dicom/" + this.id)
      .then((response) => {
        this.dicoms = response.data.data;
        this.loading = false;
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        ) {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        } else if (error.response.status == 400);
        {
          alert(error.response.data.message);
        }
      });
  },
};
</script>